import { FunctionComponent } from 'react';
import { css } from '@emotion/react';
import { Box } from '@mui/material';

import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

type DesignStepBlockHeaderLayoutProps = {
  Icon: FunctionComponent;
  title: string;
  description: string;
};

export default function DesignStepBlockHeaderLayout({ Icon, title, description }: DesignStepBlockHeaderLayoutProps) {
  const styles = useStyles();

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.iconWrapper}>
        <Icon />
      </Box>
      <Box sx={styles.texts}>
        <Text variant="h3">{title}</Text>
        <Text variant="input15" sx={{ color: COLORS.grey400 }}>
          {description}
        </Text>
      </Box>
    </Box>
  );
}

function useStyles() {
  return {
    wrapper: css`
      display: flex;
      gap: 12px;
      align-items: center;
    `,
    iconWrapper: css`
      padding: 6px;
      background-color: ${COLORS.blue50};
      border-radius: 12px;
      height: 46px;

      svg {
        width: 34px;
        height: 34px;
      }
    `,
    texts: css`
      display: flex;
      flex-direction: column;
      gap: 2px;
    `,
  };
}
